/**
 * The stylised dropdown used by the Wantlist / Pedalboard filters, shared so the
 * Add Pedal and Add Want forms match it (Jason, 2026-10-18: the forms' selects had
 * the browser's default grey box and double-arrow caret).
 *
 * Native <select> keeps its OS popup for options; only the closed control is
 * styled: gold hairline, pill radius, white fill, soft shadow, gold caret.
 */
export const FORM_SELECT_STYLE = {
  width: '100%',
  borderRadius: '25px',
  fontSize: '17px',
  fontFamily: 'Nunito, sans-serif',
  fontWeight: 400,
  backgroundColor: 'white',
  color: '#374151',
  cursor: 'pointer',
  border: '1px solid #C89F3C',
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
  padding: '0.55rem 2.4rem 0.55rem 1.1rem',
  outline: 'none',
  appearance: 'none',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  backgroundImage: "url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23C89F3C' d='M6 8L0 0h12z'/%3E%3C/svg%3E\")",
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 1rem center',
  boxSizing: 'border-box',
  verticalAlign: 'middle',
};

/** Overlay for a required select that failed validation. */
export const FORM_SELECT_INVALID_STYLE = {
  border: '2px solid #dc2626',
};
